import { render } from "./ExpenseHistory.vue?vue&type=template&id=184147cb&ts=true"
import script from "./ExpenseHistory.vue?vue&type=script&lang=ts"
export * from "./ExpenseHistory.vue?vue&type=script&lang=ts"

import "./ExpenseHistory.vue?vue&type=style&index=0&id=184147cb&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__